"use strict";

angular.module("vendor")
.directive("modelManagement", function() {
    return {
        restrict: "E",
        transclude: {
            "modelManagementHeader": "?modelManagementHeader",
            "modelManagementTable": "modelManagementTable"
        },
        bindToController: {
            ignoreSelection: "<"
        },
        templateUrl: require("./model-management.directive.html"),
        controller: ModelManagementController,
        controllerAs: "modelManagementCtrl"
    };
});

function ModelManagementController($rootScope, $scope, $controller, $state, $stateParams, StateExtensionService) {
    var _this = this;
    $scope.selectAll = {
        checkbox: false
    };
    $scope.selectedCount = 0;
    $scope.params = angular.extend({}, $stateParams);
    $scope.pagination = {};

    this.onPageChanged = function() {
        updateQueryParams();
        query();
    };

    this.updateSelection = function(selected) {
        if (_this.ignoreSelection) {
            return;
        }

        updateQueryParams();
        var params = angular.extend({}, $scope.params, {selected: selected});

        $scope.service.updateAllSelected(params).$promise.then(function onSuccess(data) {
            $scope.instances = data.results;
            _this.setCheckboxState(data);
        });
    };

    this.selectSingle = function(instance) {
        if (_this.ignoreSelection) {
            return;
        }

        this.updateSingle($scope.referenceId, instance);
    };

    this.updateCheckboxState = function updateCheckboxState() {
        if (_this.ignoreSelection) {
            return;
        }

        $scope.selectAll.checkbox = !!$scope.selectedCount;
    };

    this.onUpdateSort = function(sort) {
        $scope.params.ordering = sort;
        this.query();
    };

    this.resetListings = function() {
        $scope.$emit("requestResetListing");
    };

    this.setCheckboxState = function(data) {
        if (_this.ignoreSelection) {
            return;
        }

        $scope.totalCount = data.pagination.count;
        $scope.selectedCount = data.selected_count;
        this.updateCheckboxState();
    };

    this.updateSingle = function(referenceId, instance) {
        if (_this.ignoreSelection) {
            return;
        }

        var selected = !!instance.selected;

        $scope.service.updateSingleSelected(
            referenceId,
            selected,
            instance.id
        ).$promise.then(function(data) {
            instance = data;
            $scope.selectedCount = (instance.selected) ? $scope.selectedCount + 1 : $scope.selectedCount - 1;
            $scope.totalSelectedCount = (instance.selected) ? $scope.totalSelectedCount + 1 : $scope.totalSelectedCount - 1;
            _this.updateCheckboxState();
        });
    };

    function updateQueryParams() {
        var queryParams = {
            reference_id: $scope.referenceId,
            page: $scope.pagination.current_page
        };
        angular.extend($scope.params, queryParams);
    }

    function query() {
        $scope.service.query($scope.params).$promise.then(function onSuccess(data) {
            _this.setCheckboxState(data);
            $scope.pagination = data.pagination;
            $scope.instances = data.results;
            StateExtensionService.updateUrlParams({page: $scope.pagination.current_page});
        });
    }

    function clearSelection() {
        if (_this.ignoreSelection) {
            query();
            return;
        }

        $scope.service.updateAllSelected({selected: false, clear_selection: true}).$promise.then(function onSuccess() {
            query();
        });
    }

    clearSelection();

    $scope.$on("doResetListing", function(){
        query();
    });

    $scope.$on("queryListing", function($event, params) {
        angular.extend($scope.params, params);
        $scope.$broadcast("queryFilter");
        updateQueryParams();
        query();
    });

    $scope.$on("resetListing", function($event) {
        $scope.params = {
            reference_id: $scope.referenceId
        };
        $scope.$broadcast("queryFilter");
        query();
    });

    $scope.$on("clearSelection", function($event) {
        clearSelection();
    });

    $scope.$on("search", function($event, params) {
        angular.extend($scope.params, params);
        clearSelection();
    });
}



//////////////////
// WEBPACK FOOTER
// ./vendor/app-core/model-management/model-management.directive.js
// module id = 830
// module chunks = 0